import AlchiMaps from './AlchiMaps.svelte'

const app = new AlchiMaps({
  target: document.body,
	//props: {
	//	name: 0b0011
	//}
})

export default app
